import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyD_uF_ZmI5TKt7SGJPCaJfUHPU-HHNucvE",
  authDomain: "classmgmt-ade13.firebaseapp.com",
  projectId: "classmgmt-ade13",
  storageBucket: "classmgmt-ade13.firebasestorage.app",
  messagingSenderId: "577862558605",
  appId: "1:577862558605:web:de037000e0306c03a653c4",
  measurementId: "G-WXYGVM7GMN",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export async function signInWithGoogle() {
  const result = await signInWithPopup(auth, googleProvider);
  const idToken = await result.user.getIdToken();
  return { idToken, user: result.user };
}

export async function firebaseSignOut() {
  await signOut(auth);
}

export { auth };
